import { render, staticRenderFns } from "./memberVipLogTab.vue?vue&type=template&id=82e32136&lang=pug"
import script from "./memberVipLogTab.vue?vue&type=script&lang=js"
export * from "./memberVipLogTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports